module.exports = __webpack_public_path__ + "static/media/br_states.3a0a1499.geojson";